import Vue from 'vue'
import axios from 'axios'
import { Vuex, VuexORM, database } from "aveine-toolbox"
import VuexORMAxios from '@vuex-orm/plugin-axios'
import VuexORMisDirtyPlugin from '@vuex-orm/plugin-change-flags';
import { dataNormalizer } from 'aveine-toolbox';
import Aroma from './models/aroma'
import FoodPairing from './models/food-pairing'
import FeaturedGrape from './models/featured-grape'
import FeaturedRegion from './models/featured-region'
import AiContentReport from './models/ai-content-report'
import Quiz from './models/quiz'
import QuizAnswer from './models/quiz-answer'
import WineOfTheMonth from './models/wine-of-the-month'
import WineOfTheMonthTag from './models/wine-of-the-month-tag'
import registerDataTree from './adapter/register-data-tree'

Vue.use(Vuex)
// {'Authorization': `Bearer ` + localStorage.authToken, 'Content-Type': 'application/vnd.api+json'}
const headers = {}

// Initializing VuexORM
VuexORM.use(VuexORMAxios,
  {
  axios,
  apiRoot: "/",
  baseURL: process.env.VUE_APP_API_HOST,
  headers,
  transformResponse: (data) => {
    return Object.keys(data).length !== 0 ? dataNormalizer.documentToModel(JSON.parse(data)): null;
  },
  validateStatus: function (status) {
    if (status === 401) {
      localStorage.routeToRedirectTo = window.location.pathname;
      Vue.prototype.$auth.logout({
        returnTo: window.location.origin + "/login"
      });
    }
    return status >= 200 && status < 300; // default
  }
})

// To do : See how to use this correctly or replacing it
VuexORM.use(VuexORMisDirtyPlugin);

// Modeles propres au back-office, enregistres dans la base que la toolbox
// expose. Ils DOIVENT l'etre avant le VuexORM.install() ci-dessous : la base
// est figee a l'installation, un enregistrement posterieur ne serait jamais vu.
//
// Les arome et les accords ne sont pas dans aveine-toolbox parce que l'intranet
// est le seul client qui les edite — l'application mobile les lit a travers
// consumer-api, sans passer par vuex-orm.
database.register(Aroma)
database.register(FoodPairing)
database.register(AiContentReport)
database.register(FeaturedGrape)
database.register(FeaturedRegion)
database.register(Quiz)
database.register(QuizAnswer)
database.register(WineOfTheMonth)
database.register(WineOfTheMonthTag)

export { headers }

export const store = new Vuex.Store({
  plugins: [VuexORM.install(database)]
})

// APRES l'installation, et pas avant : registerDataTree lit model.getFields(),
// qui suppose le modele installe. Place plus haut, il levait le risque de
// planter au demarrage plutot qu'a l'enregistrement — on aurait echange une
// erreur tardive contre une erreur immediate.
//
// Enregistrer le modele dans la base ne suffit pas : le serialiseur de requetes
// lit ses options dans le dataTree de la toolbox, bati depuis une liste de
// modeles ecrite en dur la-bas. Sans cette declaration, la LECTURE fonctionne
// et l'ECRITURE plante sur « reading 'topLevelLinks' ».
registerDataTree(Aroma)
registerDataTree(FoodPairing)
registerDataTree(AiContentReport)
registerDataTree(FeaturedGrape)
registerDataTree(FeaturedRegion)
registerDataTree(Quiz)
registerDataTree(QuizAnswer)
registerDataTree(WineOfTheMonth)
registerDataTree(WineOfTheMonthTag)

